import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import {cloneObject, getParam, formatText, truncate} from '../utils/utils';
import {listNarratives} from '../utils/utilsNarrative';

import dsd from "../classes/clsDSD";

import * as PD from '../classes/pdStyle';

class ListNarratives extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            renderState: 'loading',
            Narratives : null
        };


        this.dsd = new dsd();

    }

componentDidMount(){

    this.setup();
 
}


componentDidUpdate(prevProps, prevState){

   if (!isEqual(this.props, prevProps)){
       this.setup();
   }

}

loadData(filters){

    listNarratives(
        this.dsd,
        filters,
        (data) => {
            this.setState({
                Narratives: data,
                renderState: 'loaded'
            });
            
            // Call parent's onLoad callback if provided
            if (this.state.onLoad){
                this.state.onLoad(data.length);
            }
        },
        (error) => {
            this.setState({
                renderState: 'failed',
                errorMessage: error.message || 'Failed to load narratives'
            });
        }
    );
}

setup(){

    let StateChange = {
        renderState: 'loading',
        filters: {},
        columns: {
            owner:true,
            status:true
        },
        onLoad: null
    };

    if (getParam('filters', this.props)){
        StateChange.filters = getParam('filters', this.props);
    }

    if (getParam('columns', this.props)){
        StateChange.columns = getParam('columns', this.props);
    }

    if (getParam('onLoad', this.props)){
        StateChange.onLoad = getParam('onLoad', this.props);
    }
    
    this.setState(StateChange);
    this.loadData(StateChange.filters);
        
}



    included(Narrative) {

        let IncludeThis = true;

        return IncludeThis;
    }

    render() {


        if (this.state.renderState === 'failed') {
            return (
                <PD.ErrorBox>
                    {this.state.errorMessage || 'A problem has occurred'}
                </PD.ErrorBox>
            )
        }


        if (this.state.renderState === 'loaded') {
            let arrNarratives = this.state.Narratives;
            if (isArray(arrNarratives)){
                if (arrNarratives.length > 0){

                    return (
                        <PD.Table className="list">
                            <PD.Thead>
                                <PD.Tr>
                                    <PD.Th>Name</PD.Th>
                                    {this.state.columns.owner &&
                                        <PD.Th>Owner</PD.Th>                            
                                    }
                                    {this.state.columns.status &&
                                        <PD.Th>Status</PD.Th>                            
                                    }
                                    <PD.Th>Description</PD.Th>
                                </PD.Tr>
                            </PD.Thead>

                            <PD.Tbody>

                            {
                                arrNarratives.map(
                                    (Narrative, pos) => 
                                    {
                                        if (this.included(Narrative)) {

                                            let maxRows = 1;

                                            let Rows = []
                                            for (let i = 1; i <= maxRows; i++) {
                                                Rows.push(null);
                                            }
                
                                            return (

                                                    <PD.Tr key={pos}>
                                                        <PD.Td>
                                                            <PD.PdNavLink to={"/narrative/" + Narrative.id} > {Narrative.name}</PD.PdNavLink>
                                                        </PD.Td>
                                                        {this.state.columns.owner &&
                                                            <PD.Td>
                                                                {Narrative.Owner &&
                                                                    Narrative.Owner.organisation}
                                                            </PD.Td>
                                                        }
                                                        {this.state.columns.status &&
                                                            <PD.Td>
                                                                {Narrative.status}
                                                            </PD.Td>
                                                        }

                                                        <PD.Td>
                                                            <PD.MdPresent>{truncate(Narrative.description, 400)}</PD.MdPresent>
                                                        </PD.Td>

                                                    </PD.Tr>

                                            )
                                        }
                                        else{
                                            return null;
                                        }                
                                    }
                                )
                            }
                            </PD.Tbody>

                        </PD.Table>
                    )
                }
            }
        }

        return <div />;

    };    
};
        
export default function ListNarratives_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <ListNarratives {...props} navigation={navigation} location={location} params={params} />;
  }
